import type { PropsWithChildren } from 'react';

import FormContextProvider, { useFormContext } from '~/contexts/FormContext/FormContext';
import type { OnSubmit } from '~/contexts/FormContext/types';
import type { SearchParams } from '~/utils/search/types';

export type SearchFormType = Omit<SearchParams, 'page'>;

type SearchFormContextProps = {
  params?: SearchFormType;
  onSubmit: OnSubmit<SearchFormType>;
  defaultSubmitted?: boolean;
};

export const SearchFormContextProvider = ({
  children,
  params,
  onSubmit,
  defaultSubmitted,
}: PropsWithChildren<SearchFormContextProps>) => (
  <FormContextProvider<SearchFormType>
    defaultValues={{
      job: params?.job,
      sort: params?.sort,
      type: params?.type,
      address: params?.address,
      distance: params?.distance,
      experience: params?.experience,
    }}
    onSubmit={onSubmit}
    defaultSubmitted={defaultSubmitted}
  >
    {children}
  </FormContextProvider>
);

export const useSearchFormContext = () => useFormContext<SearchFormType>();
